import {
  Component,
  EventEmitter,
  inject,
  input,
  OnInit,
  Output,
} from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { TrackingService } from "../../../../../shared/analytics/tracking.service";
import { assert } from "../../../../../shared/utils/assert";
import { BrandUrl } from "../../../../brand.url";
import { PublicationTemplateType } from "../../../publication-template/data/entities/publication-templates.entity";
import { BetaCampaignTrackingEvents } from "../../../shared/tracking/beta-campaign.tracking-events";

@Component({
  standalone: true,
  selector: "app-brand-publication-template-actions",
  templateUrl: "./brand-publication-template-actions.component.html",
  styleUrl: "./brand-publication-template-actions.component.scss",
  imports: [
    RouterLink,
    MatMenuTrigger,
    MatIcon,
    MatMenu,
    MatMenuItem,
    TranslateModule,
  ],
})
export class BrandPublicationTemplateActionsComponent implements OnInit {
  @Output() public readonly remove = new EventEmitter<void>();
  public readonly publicationType = input.required<PublicationTemplateType>();
  public readonly publicationId = input.required<string>();
  public readonly campaignId = input.required<number>();
  public readonly creatorId = input.required<number>();

  private readonly trackingService = inject(TrackingService);
  private betaCampaignEvents?: BetaCampaignTrackingEvents;
  private readonly router = inject(Router);

  protected editingUrl?: string;
  protected schedulingUrl?: string;

  public ngOnInit(): void {
    const publicationTemplateUrls = BrandUrl.Campaign.PublicationTemplate(
      this.creatorId(),
      this.campaignId(),
    );
    this.editingUrl = publicationTemplateUrls.Edit(this.publicationId());
    this.schedulingUrl = publicationTemplateUrls.Schedule(this.publicationId());
    this.betaCampaignEvents = new BetaCampaignTrackingEvents(
      this.creatorId(),
      this.trackingService,
      this.campaignId(),
    );
  }

  protected async goToScheduling(): Promise<void> {
    assert(this.schedulingUrl);
    this.betaCampaignEvents?.publicationSchedulingStarted(
      this.publicationType(),
    );
    await this.router.navigateByUrl(this.schedulingUrl);
  }
}
